import { useEffect, useState } from 'react';
import { isCookieEnabled } from 'app/utils/helpers';

export const useCheckCookieStatus = () => {
  const [cookiesOn, setCookiesOn] = useState(true);

  useEffect(() => {
    setCookiesOn(isCookieEnabled());
  }, []);

  return {
    cookiesOn,
  };
};
